export const ASPECT_RATIOS = {
  STANDARD: 'STANDARD',
  INSTA: 'INSTA',
  SQUARE: 'SQUARE',
  WIDE: 'WIDE'
};

export default function () {
  return [
  { label: 'Landscape 16:9', value: ASPECT_RATIOS.WIDE, prefix: 'monitor' },
  { label: 'Portrait 4:5', value: ASPECT_RATIOS.STANDARD, prefix: 'standard' },
  { label: 'Portrait 9:16', value: ASPECT_RATIOS.INSTA, prefix: 'portrait' },
  { label: 'Square 1:1', value: ASPECT_RATIOS.SQUARE, prefix: 'square' }];

}